<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>            
            <el-form-item label="类型：">
                <el-select v-model="searchForm.type" clearable>
                    <el-option label="开启" value="0"></el-option>
                    <el-option label="关闭" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getAgentOrderListHandle">搜索查询</el-button>
                 <el-button type="success" @click="exportAgentOrderInfoHandle">导出Excel</el-button> 
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  > 
            <el-table-column prop="iccid" label="ICCID号" width="180"></el-table-column>
             <el-table-column prop="intoNo" label="接入号" width="180"></el-table-column>
            <el-table-column prop="typeName" label="类型" width="100"></el-table-column>
            <el-table-column prop="remark" label="备注" ></el-table-column>
            <el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 

        <el-dialog :append-to-body="true"  title="订单详情" :visible.sync="orderDetailVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订单号：</label>
                <span>{{orderDetailForm.orderNo}}</span>
            </div>
            <div class="lineInDialog">
                <label>所属代理商：</label>
                <span>{{orderDetailForm.agentName}}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{orderDetailForm.iccid}}</span>
            </div>
            <div class="lineInDialog">
                <label>套餐名称：</label>
                <span>{{orderDetailForm.packageName}}</span>
            </div>
            <div class="lineInDialog">
                <label>下单金额：</label>
                <span>{{orderDetailForm.priceRmb}} 元</span>
            </div>
            <div class="lineInDialog">
                <label>支付状态：</label>
                <span>{{orderDetailForm.payStateName}}</span>
            </div>
            <div class="lineInDialog">
                <label>卡来源：</label>
                <span>{{orderDetailForm.supplierTypeCodeName}}</span>
            </div>
            <div class="lineInDialog">
                <label>我的佣金：</label>
                <span>{{orderDetailForm.commissionRmb}} 元</span>
            </div>
            <div class="lineInDialog">
                <label>下单时间：</label>
                <span>{{orderDetailForm.createTime}}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>            
        </el-dialog>   
    </div>
</template>
<script>
import {getAgentOrderLists,exportAgentOrderInfo} from '@/api/order.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                type: '',
                iccid: '',
                orderNo: '',
                investType: '',
                isCashback: '',
                time: ''
            },
            orderDetailVisible: false,
            orderDetailForm: {},
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        getAgentOrderListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getAgentOrderLists(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showOrderDetail(row){
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentOrderListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getAgentOrderListHandle();
        },
        exportAgentOrderInfoHandle($event){//导出代理商微信订单
            // var data = JSON.parse(JSON.stringify(this.searchForm));
             common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            data.token = localStorage.getItem('token');
             common.sysRequest('excels/sim/data/log', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载管理中查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })    
        }        
    },
    created(){
        this.getAgentOrderListHandle();
    }
}
</script>
<style lang="less" scoped>

</style>

